import React, { useState } from "react";
import { Link as LinkS } from "react-scroll";
import { Divide as Hamburger } from "hamburger-react";
import { FaYoutube, FaTiktok } from "react-icons/fa";
import { FaAngleRight } from "react-icons/fa";

import "./red-navbar-section.scss";

const RedNavbarSection = ({
  switchFunction,
  horizontalScrolling,
}) => {
  const [firstTimeIsActive, setFirstTimeIsActive] = useState(false);
  const [isOpen, setOpen] = useState(false);

  const setActive = () => {
    setOpen(!isOpen);
    if (!firstTimeIsActive) {
      setFirstTimeIsActive(true);
    }
  };

  return (
    <div className="navbar-section">
      <div className="navbar">
        <LinkS
          onClick={setActive}
          className="navbar-logo"
          duration={500}
          to="homePage"
          spy={true}
          exact="true"
          smooth={true}
          horizontal={horizontalScrolling}
        />

        <div className="navbar-line first" />

        <div className={`navbar-menu ${isOpen ? "is-open" : "is-close"}`}>
          {/* --- Főoldal --- */}
          <LinkS
            onClick={setActive}
            className={`menu-item ${
              firstTimeIsActive ? "activated" : "first"
            }`}
            horizontal={horizontalScrolling}
            duration={500}
            to="homePage"
            spy={true}
            exact="true"
            smooth={true}
          >
            Főoldal
            <div className="navbar-background elso active" />
          </LinkS>

          {/* --- Információk --- */}
          <LinkS
            onClick={setActive}
            className={`menu-item ${
              firstTimeIsActive ? "activated" : ""
            }`}
            horizontal={horizontalScrolling}
            to="infoPage"
            spy={true}
            smooth={true}
            exact="true"
            duration={500}
          >
            Információk
            <div className="navbar-background masodik" />
          </LinkS>

          {/* --- Gyik --- */}
          <LinkS
            onClick={setActive}
            className={`menu-item ${
              firstTimeIsActive ? "activated" : ""
            }`}
            horizontal={horizontalScrolling}
            to="gyikPage"
            spy={true}
            smooth={true}
            exact="true"
            duration={500}
          >
            Gyik
            <div className="navbar-background harmadik" />
          </LinkS>

          {/* --- Média --- */}
          <LinkS
            onClick={setActive}
            className={`menu-item ${
              firstTimeIsActive ? "activated" : ""
            }`}
            horizontal={horizontalScrolling}
            to="mediaPage"
            spy={true}
            smooth={true}
            exact="true"
            duration={500}
          >
            Média
            <div className="navbar-background negyedik" />
          </LinkS>
        </div>

        <div className="navbar-line" />

        {/* JOBB FELSŐ ICONS (play/pause/spinner eltávolítva) */}
        <div className="navbar-top-right">
          <div className="hamburger">
            <Hamburger toggled={isOpen} toggle={setOpen} />
          </div>

          <FaAngleRight className="next" onClick={switchFunction} />
        </div>
      </div>

      <div className="navbar-center"></div>

      <div className="navbar-bottom">
        <div className="navbar-line" />

        <a
          href="https://www.youtube.com/@awrphun"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaYoutube className="youtube-icon" />
        </a>

        <a
          href="https://tiktok.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTiktok className="tiktok-icon" />
        </a>
      </div>
    </div>
  );
};

export default RedNavbarSection;
